import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { useAuthStore } from '@/entities/auth/store'
import * as Sentry from '@sentry/vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes,
})

router.beforeEach(async (to, _from) => {
  document.title = `Syntech ERP | ${to.meta.title}`

  const globalAuthStore = useAuthStore()

  if (to.meta.requiresAuth && !globalAuthStore.isAuthenticated) {
    return {
      path: '/',
      query: { redirect: to.fullPath },
    }
  }

  if (!to.meta.requiresAuth && globalAuthStore.isAuthenticated) {
    return '/dashboard'
  }
})

router.afterEach((to) => {
  const routeName = String(to.name || '')
  const module = routeName.replace(/^(List|Add|Edit)/, '') || 'root'
  Sentry.setTag('module', module)
})

router.onError((error) => {
  Sentry.captureException(error, {
    tags: { source: 'router' },
  })
})

export default router
